export default __webpack_public_path__ + "static/fonts/OpenDyslexic.26f17dd.woff";